import { useEffect, useRef, useState } from "react";
import styles from "../styles/styles.module.css";
import { useNavigate } from "react-router-dom";
import useSurvey from "../../../pages/surveys/hooks/useSurvey";
import useAlert from "../../../hooks/useAlert";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as PauseIcon } from "../../../assets/icons/pause-icon.svg";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete-icon.svg";
import { ReactComponent as MoreHorizontalIcon } from "../../../assets/icons/more-horizontal-icon.svg";
import { ReactComponent as BackIcon } from "../../../assets/icons/arrow-left.svg";
import { ReactComponent as CloudIcon } from "../../../assets/icons/cloud-icon.svg";
import { setLoadingSurvey } from "../../../redux/slices/loadingSurvey";
import { Button, Dropdown, Input, Menu, Spin } from "antd";
import { statusColors } from "../../../utils/constants";
import { setSurveyInfo } from "../../../redux/slices/surveyInfo";

const SurveyHeader = ({ surveyInfo, getSurveyInfoHandler }) => {
  const [totalQuestions, setTotalQuestions] = useState(undefined);
  const push = useNavigate();
  const { onSurveyOperation, saveInitialSurveyInfo, publishSurvey } =
    useSurvey();
  const { showAlert } = useAlert();
  const [name, setName] = useState(surveyInfo?.survey_name);
  const [isPublishing, setIsPublishing] = useState(false);
  const loadingSurvey = useSelector((state) => state.loadingSurvey);
  const dispatch = useDispatch();
  const refTime = useRef(null);

  const items = (
    <Menu>
      <Menu.Item
        key="1"
        icon={surveyInfo?.state !== 3 ? <PauseIcon /> : <PlayIcon />}
        onClick={() => {
          showAlert({
            title:
              surveyInfo?.state !== 3
                ? "¿Pausar encuesta?"
                : "¿Reanudar encuesta?",
            content:
              surveyInfo?.state !== 3
                ? "Mientras la encuesta esté pausada, los usuarios no podrán responderla. Podrás reanudarla en cualquier momento."
                : "La encuesta estará activa nuevamente y los usuarios podrán responderla.",
            status: "warning",
            onOk: async () => {
              if (!surveyInfo?.id) return;

              const res = await onSurveyOperation({
                operation: surveyInfo.state !== 3 ? "pause" : "resume",
                id_survey: surveyInfo.id,
              });
              if (res) {
                getSurveyInfoHandler(surveyInfo.id);
              }
            },
          });
        }}
      >
        {surveyInfo?.state !== 3 ? "Pausar" : "Reanudar"}
      </Menu.Item>

      <Menu.Item
        key="2"
        icon={<DeleteIcon />}
        danger
        onClick={() => {
          showAlert({
            title: "¿Eliminar encuesta?",
            content:
              "Esta acción no se puede deshacer. La encuesta y todos sus datos asociados serán eliminados permanentemente.",
            onOk: async () => {
              if (!surveyInfo?.id) return;

              const res = await onSurveyOperation({
                operation: "delete",
                id_survey: surveyInfo.id,
              });
              if (res) {
                push("/ajustes/encuestas");
              }
            },
          });
        }}
      >
        Eliminar
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    getTotalQuestion();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyInfo]);

  const getTotalQuestion = () => {
    if (!surveyInfo) return;

    let total = 0;
    for (const surveyItem of surveyInfo.surveyPages) {
      total += surveyItem.surveyQuestions.length;
    }

    total += surveyInfo.page_initial.length;

    setTotalQuestions(total);
  };

  const saveInitialSurveyInfoHandler = async (newName) => {
    if (!surveyInfo) return alert("No existe una encuesta");

    dispatch(setLoadingSurvey(true));
    await saveInitialSurveyInfo({
      id_survey: surveyInfo.id,
      description: surveyInfo.description,
      title: surveyInfo.title,
      survey_name: newName,
    });
    await getSurveyInfoHandler(surveyInfo.id);
    dispatch(setLoadingSurvey(false));
  };

  return (
    <header className={styles["survey-header"]}>
      <div className={styles["survey-title-container"]}>
        <Button
          onClick={() => {
            push("/ajustes/encuestas");
            dispatch(setSurveyInfo(null));
          }}
          className={styles["survey-header-btn"]}
          icon={<BackIcon />}
          type="primary"
          shape="round"
        />
        <Input
          title={name}
          value={name}
          onChange={(e) => {
            setName(e.target.value);

            if (refTime.current) {
              clearTimeout(refTime.current);
            }
            refTime.current = setTimeout(() => {
              saveInitialSurveyInfoHandler(e.target.value);
            }, 1000);
          }}
          className={styles["survey-header-input"]}
          bordered={false}
        />
      </div>

      <div className={styles["survey-header-info"]}>
        <div className={styles["survey-cloud-item"]}>
          {!loadingSurvey ? (
            <CloudIcon style={{ color: statusColors[1] }} />
          ) : (
            <Spin />
          )}
          <span>{!loadingSurvey ? "Guardado" : "Guardando..."} </span>
        </div>

        <div className={styles["survey-header-info-item"]}>
          <span>Preguntas totales</span>
          <span>{totalQuestions}</span>
        </div>
        {/* 
        <Button
          shape="round"
          className={styles["survey-header-btn"]}
          icon={<EyeIcon />}
        />

        <Dropdown overlay={copyItems}>
          <Button
            shape="round"
            className={styles["survey-header-btn"]}
            icon={<ClipIcon />}
          />
        </Dropdown> */}

        <span className={styles["survey-header-info-status"]}>
          {surveyInfo?.state_name}
        </span>

        <Button
          loading={isPublishing}
          onClick={async () => {
            setIsPublishing(true);
            await publishSurvey(surveyInfo.id);
            await getSurveyInfoHandler(surveyInfo.id);
            setIsPublishing(false);
          }}
          type="primary"
          className={styles["survey-header-post"]}
          disabled={![2,3].includes(surveyInfo.state)}
          title={![2,3].includes(surveyInfo.state) ? 'La encuesta se encuentra activa o finalizada' : undefined}
        >
          Publicar
        </Button>

        <Dropdown overlay={items}>
          <Button
            shape="round"
            className={styles["survey-header-btn"]}
            icon={<MoreHorizontalIcon />}
          />
        </Dropdown>
      </div>
    </header>
  );
};

export default SurveyHeader;
